import { render } from "./UserCriteriaView.vue?vue&type=template&id=3ae406dc"
import script from "./UserCriteriaView.vue?vue&type=script&lang=js"
export * from "./UserCriteriaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__